// extracted by mini-css-extract-plugin
export default {"compareButton":"CompareButton_compareButton__jGjne","active":"CompareButton_active__o7y4v"};